import { z } from "zod";

/**
 * The signed-in user's "email me when this list runs" setting (PREC-3908).
 *
 * `isDefault` distinguishes "the list's default happens to be on" from "this user turned it on".
 * Only the list's creator has a default at all — everyone else starts off — so the flag is what
 * lets the settings screen say the toggle is still following the list's cadence.
 */
export const ListRunEmailSubscriptionSchema = z.object({
	enabled: z.boolean(),
	isDefault: z.boolean(),
});

export type ListRunEmailSubscription = z.infer<typeof ListRunEmailSubscriptionSchema>;
